import React from 'react'
import { connect } from 'react-redux'
import { colors } from 'helpers/helpers.js'
import getSelectedCoinObj from 'selectors/selectedCoinObj'
import getPlatformsOfCoin from 'selectors/platformsOfCoin'
import cn from 'classnames'
import './styles.css'

const socialMediaBox = ({
  coin,
  platformsOfCoin,
  hiddenPlatforms,
  hidePlatform,
  showPlatform,
  inSatoshi,
  highlightedPlatform,
  highlightPlatform,
  mobileVersion
}) => {

  const { website, twitter, reddit, telegram, bitcointalk, discord } = coin //medium
  // if searchName is '-' it means there should be no searching cause the coin name is to broad.
  const reddit_m = coin.searchName === '-' ? undefined : (coin.searchName || coin.name || coin.apiSymbol)
  const reddit_ms = reddit_m

  const redditClicked   = () =>   window.open('https://www.reddit.com/r/' + reddit , '_blank')
  const telegramClicked = () =>   window.open('https://t.me/' + telegram , '_blank')
  const discordClicked = () =>    window.open('https://discordapp.com/invite/' + discord , '_blank')
  const bTalkClicked    = () =>   window.open('https://bitcointalk.org/index.php?topic=' + bitcointalk , '_blank')
  const websiteClicked  = () =>   window.open(website, '_blank')

  const toggleVP = (pl) => {
    hiddenPlatforms.includes(pl) ? showPlatform(pl) : hidePlatform(pl)
  }

  const highlight = (pl) => {
    highlightPlatform(pl)
  }

  const renderRow = (text, clickFunc, platformTarget, platform) => {
    const eyeActive = !hiddenPlatforms.includes(platform)
    const chartActive = platform === highlightedPlatform
    const eyeCol = eyeActive ? (colors[platform] || 'grey') : '#383f4a'
    const chartCol = chartActive ? (colors[platform] || 'grey') : '#383f4a'

    return(
      <fb className={cn({['row']: 1, mobileVersion}) } >
          <fb className="iconsWrapper" >
            { !mobileVersion && <fb className="chartIc icon icon-poll" style={{ color: chartCol, visibility: platform === 'price' ? 'hidden' : 'visible' }} onClick={() => highlight(platform)}></fb> }
            <fb className="eye icon icon-visibility" style={{ backgroundColor: eyeCol }} onClick={() => toggleVP(platform)}></fb>
          </fb>
        <fb className="textWrapper">
          <fb className={'cli'}>{text}</fb>
          { !mobileVersion && <fb className='detail' onClick={clickFunc || (()=>{})}>{ platformTarget }</fb>}
        </fb>
      </fb>
  )}

  return (
    <fb className={cn({linksMain: 1, mobileVersion})}>
      <fb className={cn({linksWrapper: 1, mobileVersion})}>
        { renderRow('Price in ' + ( inSatoshi ? 'Satoshi' : 'BTC' ), ()=>{}, null, 'price') }
        { reddit     && renderRow('Reddit Subscribers', redditClicked, 'https://www.reddit.com/r/' + reddit, 'reddit') }
        { reddit     && renderRow('Reddit Active Users', redditClicked, 'https://www.reddit.com/r/' + reddit, 'reddit_a') }
        { telegram   && renderRow('Telegram Members', telegramClicked, 'https://t.me/' + telegram, 'telegram') }
        { telegram   && renderRow('Telegram Members Online', telegramClicked, 'https://t.me/' + telegram, 'telegram_a') }
        { bitcointalk     && renderRow('Bitcointalk Reads', bTalkClicked, 'topic= ' + bitcointalk, 'bitcointalk') }
        { discord     && renderRow('Discord Members', discordClicked, 'https://discordapp.com/invite/' + discord , 'discord') }
        { discord     && renderRow('Discord Members Online', discordClicked, 'https://discordapp.com/invite/' + discord , 'discord_a') }
        { reddit_m    && renderRow('Reddit comments mentions', undefined, '' + reddit_m , 'reddit_m') }
        { reddit_ms   && renderRow('Reddit submission mentions', undefined, '' + reddit_ms , 'reddit_ms') }
      </fb>
      <fb className="websiteRow" onClick={websiteClicked}>{ website }</fb>
    </fb>
  )
}

const actionsToProps = {
  highlightPlatform: (platform) => ({ type: 'HIGHLIGHT_PLATFORM', payload: platform }),
  showPlatform: (platform) => ({ type: 'SHOW_PLATFORM', payload: platform }),
  hidePlatform: (platform) => ({ type: 'HIDE_PLATFORM', payload: platform }),
}

const mapStateToProps = (state: Store) => ({
  coin: getSelectedCoinObj(state),
  latestCounts: state.currentCount,
  hiddenPlatforms: state.ui.hiddenPlatforms,
  highlightedPlatform: state.ui.highlightedPlatform,
  platformsOfCoin: getPlatformsOfCoin(state),
  inSatoshi: state.priceInSatoshi,
})

export default connect(mapStateToProps, actionsToProps)(socialMediaBox)



// WEBPACK FOOTER //
// ./src/containers/components/socialMediaBox/index.js